// dependencies
import React, { useContext } from "react";

const availabilities = React.createContext({
  dayStates: null,
});

const { Provider } = availabilities;

export const AvailabilitiesProvider = Provider;

export const useAvailabilities = () => {
  const context = useContext(availabilities);

  return context;
};
